module.exports = __webpack_public_path__ + "static/media/treatments.3f045271.jpg";